export class TrackingCookie {

    private readonly DOMAIN = '.bootsnall.com';

    private readonly expiration_days: number = 30;
    private readonly name: string = '';

    constructor(name: string, expire: number = 30) {
        this.name = name;
        this.expiration_days = expire;
    }

    public set(value: any) {
        let d = new Date();
        d.setTime(d.getTime() + (this.expiration_days * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = this.name + "=" + value + "; " + expires + "; domain=" + this.DOMAIN + "; path=/";
    }

    public del() {
        document.cookie = encodeURIComponent(this.name) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=" + this.DOMAIN + "; path=/";
    }

    public get(defaultValue: any = undefined) {
        const cookie = document.cookie;
        const cookies = cookie.split(';');

        let out = typeof defaultValue !== 'undefined' ? defaultValue : false;

        for (let i = 0; i < cookies.length; i++) {
            var parts = cookies[i].split('=');

            if (parts.length == 2) {
                const cookie_name_stored = this.trim(parts[0]);
                if (this.name == cookie_name_stored) {
                    const cookie_value = decodeURIComponent(parts[1]);
                    if (cookie_value) {
                        out = cookie_value;
                    }
                }
            }
        }

        return out;
    }

    private trim(str: string) {
        return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }


}